import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import styles from "./styles";
import { Link } from "react-router-dom";

import { Typography, withStyles } from "@material-ui/core";
import config, { title } from "../../config";
import { Wrapper } from "..";
import { ReactComponent as PoiIcon } from "../../assets/images/icons/3d.svg";

const Welcome = props => {
	const { classes } = props;
	const { buildings } = config;
	return (
		<Wrapper className={classes.welcome}>
			<Typography className={classes.title} variant="h1">
				{title}
			</Typography>
			{buildings.map((building, index) => (
				<Link
					key={`${building.name}`}
					className={classNames(classes.poi)}
					style={{
						left: building.button.x,
						top: building.button.y
					}}
					to={{
						pathname: `/batiment/${building.name}`,
						state: {
							prevPath: window.location.pathname
						}
					}}
				>
					<PoiIcon className={classNames(classes.icon)} />
				</Link>
			))}
		</Wrapper>
	);
};

Welcome.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Welcome);
